import { SearchAppsEndAction } from "../actions/SearchApps";
import { AppState } from "../state";

export function searchApps(state: AppState, action: SearchAppsEndAction): AppState {
    const { error, result } = action.payload;

    const errorMap = { ...state.errorMap };
    errorMap[action.type] = error;

    const searchAppsResult = result ? result : state.searchAppsResult;

    return { ...state, errorMap, searchAppsResult };
}
